export default __webpack_public_path__ + "static/media/s22zXX.680aadde.png";